import { render, staticRenderFns } from "./billingPageWrapper.vue?vue&type=template&id=4c4f223b&scoped=true&lang=html&"
import script from "./billingPageWrapper.vue?vue&type=script&lang=js&"
export * from "./billingPageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./billingPageWrapper.vue?vue&type=style&index=0&id=4c4f223b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f223b",
  null
  
)

export default component.exports